module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addKVLive"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("KV直播")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("添加直播")])], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.editRules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "直播标题",
      "prop": "liveTitle"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.liveTitle),
      callback: function($$v) {
        _vm.form.liveTitle = $$v
      },
      expression: "form.liveTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投放公司",
      "prop": "fromCompany"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.fromCompany),
      callback: function($$v) {
        _vm.form.fromCompany = $$v
      },
      expression: "form.fromCompany"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "执行者",
      "prop": "userId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择执行"
    },
    model: {
      value: (_vm.form.userId),
      callback: function($$v) {
        _vm.form.userId = $$v
      },
      expression: "form.userId"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.userName,
        "value": item.userId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "isOpenComment"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    model: {
      value: (_vm.form.isOpenComment),
      callback: function($$v) {
        _vm.form.isOpenComment = $$v
      },
      expression: "form.isOpenComment"
    }
  }, [_vm._v("开启评论")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "isLiveBgImg"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": function($event) {
        _vm.changeIsLiveBgImg()
      }
    },
    model: {
      value: (_vm.form.isLiveBgImg),
      callback: function($$v) {
        _vm.form.isLiveBgImg = $$v
      },
      expression: "form.isLiveBgImg"
    }
  }, [_vm._v("设置背景图")])], 1), _vm._v(" "), _c('el-form-item', {
    ref: "liveBgImg",
    attrs: {
      "label": "",
      "prop": "liveBgImg"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isLiveBgImg,
      "placeholder": "背景图链接（尺寸940px*1136px）"
    },
    model: {
      value: (_vm.form.liveBgImg),
      callback: function($$v) {
        _vm.form.liveBgImg = $$v
      },
      expression: "form.liveBgImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播源",
      "prop": "liveSource"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择直播源"
    },
    on: {
      "change": function($event) {
        _vm.changeLiveSource()
      }
    },
    model: {
      value: (_vm.form.liveSource),
      callback: function($$v) {
        _vm.form.liveSource = $$v
      },
      expression: "form.liveSource"
    }
  }, _vm._l((_vm.form.liveSourceList), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "缩略图",
      "prop": "otherImg"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.liveSource.otherImg,
      "placeholder": "背景图链接（尺寸16：9）"
    },
    model: {
      value: (_vm.form.otherImg),
      callback: function($$v) {
        _vm.form.otherImg = $$v
      },
      expression: "form.otherImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播链接",
      "prop": "liveUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.liveSource.name
    },
    model: {
      value: (_vm.form.liveUrl),
      callback: function($$v) {
        _vm.form.liveUrl = $$v
      },
      expression: "form.liveUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播描述",
      "prop": "liveContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入直播描述"
    },
    model: {
      value: (_vm.form.liveContent),
      callback: function($$v) {
        _vm.form.liveContent = $$v
      },
      expression: "form.liveContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "isShare"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": function($event) {
        _vm.changeShare()
      }
    },
    model: {
      value: (_vm.form.isShare),
      callback: function($$v) {
        _vm.form.isShare = $$v
      },
      expression: "form.isShare"
    }
  }, [_vm._v("开启分享")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享链接",
      "prop": "shareUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isShare,
      "placeholder": "请输入分享链接（选填）"
    },
    model: {
      value: (_vm.form.shareUrl),
      callback: function($$v) {
        _vm.form.shareUrl = $$v
      },
      expression: "form.shareUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享头图",
      "prop": "shareImg"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isShare,
      "placeholder": "请输入分享头图，尺寸200x200（必填）"
    },
    model: {
      value: (_vm.form.shareImg),
      callback: function($$v) {
        _vm.form.shareImg = $$v
      },
      expression: "form.shareImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享标题",
      "prop": "shareTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isShare,
      "placeholder": "请输入分享标题（必填）"
    },
    model: {
      value: (_vm.form.shareTitle),
      callback: function($$v) {
        _vm.form.shareTitle = $$v
      },
      expression: "form.shareTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享描述",
      "prop": "shareDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isShare,
      "placeholder": "请输入分享描述（必填）"
    },
    model: {
      value: (_vm.form.shareDesc),
      callback: function($$v) {
        _vm.form.shareDesc = $$v
      },
      expression: "form.shareDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm()
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm('form')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0ab5443a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/kvlive/Add.vue
// module id = 729
// module chunks = 1